// extracted by mini-css-extract-plugin
module.exports = {"button":"button-1YNRZ","icon":"icon-3o1LJ","text":"text-3jcYh"};